import { useRef, useState } from 'react';
import type { HistoryItem } from '../components/MatchmakingHistoryPopover';

/**
 * Feature 060: Removed ServiceRangeOption import and related state
 */
export type StepperAnswers = {
  answer_q1: string;
  answer_q2: string;
  answer_q3: string;
};

export const useMatchmakingStateManagement = () => {
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [isClientModalOpen, setClientModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [showNoProvidersFound, setShowNoProvidersFound] = useState(false);
  const [noProviderMessage, setNoProviderMessage] = useState<string | null>(null);
  const [loadMoreMessage, setLoadMoreMessage] = useState<string | null>(null);
  const [searchCounter, setSearchCounter] = useState(0);
  const [isHistoryPopoverOpen, setHistoryPopoverOpen] = useState(false);
  const [showClientInfoTooltip, setShowClientInfoTooltip] = useState(false);
  const [showHistoryTooltip, setShowHistoryTooltip] = useState(false);
  const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);
  const [isViewingHistoryResults, setIsViewingHistoryResults] = useState(false);
  const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);
  const [isHistoryDetailsModalOpen, setIsHistoryDetailsModalOpen] = useState(false);
  const [selectedAddress, setSelectedAddress] = useState<string>('');
  const [selectedLatitude, setSelectedLatitude] = useState<number | null>(null);
  const [selectedLongitude, setSelectedLongitude] = useState<number | null>(null);
  const [selectedState, setSelectedState] = useState<string>('');
  const [selectedCounty, setSelectedCounty] = useState<string>('');
  const [selectedZipCode, setSelectedZipCode] = useState<string>('');
  const [addressResetTrigger] = useState(0);
  const [shouldFetchHistory, setShouldFetchHistory] = useState(false);
  const [currentSearchId, setCurrentSearchId] = useState<number | null>(null);
  const [loadCount, setLoadCount] = useState<number>(0);
  const [stepperAnswers, setStepperAnswers] = useState<StepperAnswers>({
    answer_q1: '',
    answer_q2: '',
    answer_q3: '',
  });

  const lastHistoryItemRef = useRef<HistoryItem | null>(null);
  const lastPromptRef = useRef<string>('');

  return {
    isDrawerOpen,
    setDrawerOpen,
    isClientModalOpen,
    setClientModalOpen,
    isLoading,
    setIsLoading,
    isLoadingMore,
    setIsLoadingMore,
    error,
    setError,
    showNoProvidersFound,
    setShowNoProvidersFound,
    noProviderMessage,
    setNoProviderMessage,
    loadMoreMessage,
    setLoadMoreMessage,
    searchCounter,
    setSearchCounter,
    isHistoryPopoverOpen,
    setHistoryPopoverOpen,
    showClientInfoTooltip,
    setShowClientInfoTooltip,
    showHistoryTooltip,
    setShowHistoryTooltip,
    isLocationModalOpen,
    setIsLocationModalOpen,
    isViewingHistoryResults,
    setIsViewingHistoryResults,
    isSupportModalOpen,
    setIsSupportModalOpen,
    isHistoryDetailsModalOpen,
    setIsHistoryDetailsModalOpen,
    selectedAddress,
    setSelectedAddress,
    selectedLatitude,
    setSelectedLatitude,
    selectedLongitude,
    setSelectedLongitude,
    selectedState,
    setSelectedState,
    selectedCounty,
    setSelectedCounty,
    selectedZipCode,
    setSelectedZipCode,
    addressResetTrigger,
    shouldFetchHistory,
    setShouldFetchHistory,
    currentSearchId,
    setCurrentSearchId,
    loadCount,
    setLoadCount,
    stepperAnswers,
    setStepperAnswers,
    lastHistoryItemRef,
    lastPromptRef,
  };
};

